module.exports = __webpack_public_path__ + "img/Wp_2063.7c53a89c.png";